import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()

  // Wait for app to be mounted before accessing stores (Pinia is ready by then)
  nuxtApp.hook('app:mounted', async () => {
    console.log('🚀 App mounted, initializing auth...')
    
    // Function to check and restore auth state - defined inside the hook
    const checkAndRestoreAuth = async () => {
      if (typeof window === 'undefined') return

      try {
        const authStore = resolveAuthStore()
        if (!authStore) {
          return
        }
        
        // Force store rehydration
        const storedData = localStorage.getItem('auth:token')
        console.log('🔍 Checking stored token:', storedData ? 'Found' : 'Not found')
        
        if (storedData) {
          try {
            const parsed = JSON.parse(storedData)
            if (parsed.token && !authStore.token) {
              console.log('🔄 Rehydrating auth store with stored token')
              authStore.setToken(parsed.token, parsed.expiresAt, parsed.isRemembered)
            }
          } catch (error) {
            console.error('❌ Error parsing stored token:', error)
          }
        }

        if (authStore.token) {
          console.log('🔄 Restoring auth session')
          try {
            const tokenData = authStore.tokenData
            if (tokenData && tokenData.exp) {
              const now = Math.floor(Date.now() / 1000)
              const timeUntilExpiry = tokenData.exp - now

              if (timeUntilExpiry <= 0) {
                console.log('⚠️ Token expired during initialization')
                authStore.logout()
                return
              }

              if (timeUntilExpiry < 300) { // 5 minutes
                console.log('🔄 Refreshing token during initialization')
                await authStore.refreshToken()
              }
              
              // Verify and restore session
              const isValid = await authStore.checkAuth()
              if (!isValid) {
                console.log('⚠️ Invalid session during initialization')
                authStore.logout()
              } else {
                console.log('✅ Auth session restored successfully')
              }
            }
          } catch (error) {
            console.error('❌ Failed to restore auth session:', error)
            authStore.logout()
          }
        }
      } catch (error) {
        console.error('❌ Error accessing auth store:', error)
      }
    }

    // Initial auth check
    await checkAndRestoreAuth()

    // Add navigation hook to check auth on page changes
    nuxtApp.hook('page:start', async () => {
      console.log('📄 Page navigation started')
      try {
        await checkAndRestoreAuth()
      } catch (error) {
        console.error('❌ Error checking auth on page navigation:', error)
      }
    })
  })
}) 